var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#56E612"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_318_11086)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 28.3333C15.3976 28.3333 11.6667 24.6025 11.6667 20C11.6667 15.3975 15.3976 11.6667 20.0001 11.6667C24.6026 11.6667 28.3334 15.3975 28.3334 20C28.3334 24.6025 24.6026 28.3333 20.0001 28.3333ZM20.0001 26.6667C21.7682 26.6667 23.4639 25.9643 24.7141 24.714C25.9644 23.4638 26.6667 21.7681 26.6667 20C26.6667 18.2319 25.9644 16.5362 24.7141 15.286C23.4639 14.0357 21.7682 13.3333 20.0001 13.3333C18.232 13.3333 16.5363 14.0357 15.286 15.286C14.0358 16.5362 13.3334 18.2319 13.3334 20C13.3334 21.7681 14.0358 23.4638 15.286 24.714C16.5363 25.9643 18.232 26.6667 20.0001 26.6667ZM19.1692 23.3333L15.6334 19.7975L16.8117 18.6192L19.1692 20.9767L23.8826 16.2625L25.0617 17.4408L19.1692 23.3333Z",
    fill: "#56E612"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_318_11086"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertSuccess);
export default __webpack_public_path__ + "static/media/alert-success.129c8498b391b5a968fb63740ee4d1b7.svg";
export { ForwardRef as ReactComponent };